// extracted by mini-css-extract-plugin
export var closeBtn = "Modal-module--closeBtn--fe914";
export var modal = "Modal-module--modal--86ea5";
export var modalContainer = "Modal-module--modalContainer--8f9f5";